export default __webpack_public_path__ + "static/media/about-1.945a0b4a.jpg";